// US2028928: Modern UI soft-launch toggle API client
import { authFetch } from "../utils/authFetch";

const BASE = "/api/v1/modern-ui-launch";

/**
 * Fetch the current Modern UI soft-launch status.
 *
 * @param {Object} options - Fetch options (supports AbortController signal)
 * @returns {Promise<{enabled: boolean, updatedAt: string, updatedBy: string}>}
 * @throws {Error} On non-OK HTTP response
 */
export async function fetchModernUILaunchStatus(options = {}) {
  const { headers: callerHeaders, signal, ...rest } = options;
  const response = await authFetch(BASE, {
    method: "GET",
    ...rest,
    signal,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      ...callerHeaders,
    },
  });
  if (!response.ok) {
    const err = new Error(`fetchModernUILaunchStatus failed: ${response.status}`);
    err.code = `HTTP_${response.status}`;
    err.status = response.status;
    throw err;
  }
  return response.json();
}

/**
 * Set the Modern UI soft-launch enabled state.
 *
 * The backend requires X-Requested-With for CSRF protection on mutating
 * requests.
 *
 * @param {boolean} enabled - New enabled state
 * @returns {Promise<{enabled: boolean, updatedAt: string, updatedBy: string}>}
 * @throws {Error} On non-OK HTTP response (err.code and err.status populated)
 */
export async function setModernUILaunchStatus(enabled) {
  const response = await authFetch(BASE, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ enabled }),
  });

  if (!response.ok) {
    let body = {};
    try {
      body = await response.json();
    } catch (_) {
      // ignore parse error; use fallback message
    }
    const err = new Error(
      body?.error?.message || `setModernUILaunchStatus failed: ${response.status}`
    );
    err.code = body?.error?.code || `HTTP_${response.status}`;
    err.status = response.status;
    throw err;
  }

  return response.json();
}
